export default (score) => {
  score = parseInt(score || 0)
  if (score > 1000000) {
    score = parseInt(score / 100000) / 10 + 'M'
  } else if (score >= 1000) {
    score = parseInt(score / 100) / 10 + 'K'
  }
  return score
}



// WEBPACK FOOTER //
// src/helper/score.js